
export default () => Date.now()



// WEBPACK FOOTER //
// ./src/utils/getComponentKey.js